<style lang="scss">
@import './index.scss';
</style>
<template>
  <div>
    <div class="funnel">
          <div class="funnel-title">
              <h1 class="funnel-title-h3">{{ $t('funnel.title') }}</h1>
          </div>
          <div class="funnel-view">
              <table-page
                  search-del
                  ref="tablepage"
                  @on-del-manage-event="showDelModal">
                  <i-button @click="setFunnel" icon="md-add" class="funnel-view-btn" type="primary" shape="circle" slot="lefttool">{{ $t('funnel.funnelBtn') }}</i-button>
              </table-page>
          </div>
    </div>
    <Modal
        v-model="delModal"
        title=''
        @on-ok="delFunnel"
        @on-cancel="cancel">
        <p class="manage-event-paragraph">{{ $t('funnel.delinfo') }}</p>
    </Modal>
  </div>
</template>
<script>
import safeHtml from '../../filters/html-formate';
import tablePage from '../../components/app-overview/table-move';
import $ from '../../libs/util';
import bus from '../../libs/bus';
import ln from '../../libs/locale';

export default {
  props: {},
  data() {
    return {
      delModal: false,
      delSelection: [],
    };
  },
  components: {
    tablePage,
  },
  mounted() {
    const self = this;
    bus.$on('on-app-change', () => {
      self.init();
    });
    bus.$on('on-platform-change', () => {
      self.init();
    });
    bus.$on('on-conditions-change', () => {
      self.init();
    });
    bus.$on('on-date-change', () => {
      self.init();
    });
    bus.$on('on-change-lang', this.setTableColumn);
    if (!bus.productInfo.productid) {
      return;
    }
    this.init();
  },
  beforeDestroy() {
    bus.$off('on-app-change');
    bus.$off('on-platform-change');
    bus.$off('on-conditions-change');
    bus.$off('on-date-change');
    bus.$off('on-change-lang', this.setTableColumn);
  },
  methods: {
    init() {
      this.$refs.tablepage.clearData();
      this.setTableData();
    },
    // 获取数据
    getData(params) {
      return $.ajax.post('app/rest/data.json/query', params);
    },
    setTableColumn() {
      const self = this;
      const name = ln[bus.lang].funnel;
      const columns = [
        {
          type: 'selection',
          width: 50,
          align: 'center',
        },
        {
          title: name.funnelname,
          key: 'name',
          render(h, params) {
            return h('p', {
              class: {
                textEllipsis: true,
              },
              attrs: {
                title: safeHtml(params.row.name),
              },
            }, [
              safeHtml(params.row.name),
            ]);
          },
        },
        {
          title: name.start,
          key: 'steponename',
          align: 'left',
          render(h, params) {
            return h('p', {
              class: {
                textEllipsis: true,
              },
              attrs: {
                title: safeHtml(params.row.steponename),
              },
            }, [
              safeHtml(params.row.steponename),
            ]);
          },
        },
        {
          title: name.end,
          key: 'endname',
          align: 'left',
          render(h, params) {
            return h('p', {
              class: {
                textEllipsis: true,
              },
              attrs: {
                title: safeHtml(params.row.endname),
              },
            }, [
              safeHtml(params.row.endname),
            ]);
          },
        },
        {
          title: name.set,
          key: 'set',
          align: 'left',
          render(h, params) {
            return h('div', [
              h('a', {
                class: {
                  'iconfont': true,
                  'icon-Details': true,
                  'tm-icon-font': true,
                  'tm-icon-font-operation': true,
                },
                style: {
                  cursor: 'pointer',
                },
                on: {
                  click: () => {
                    self.returnFunnelChart(params.row.name, params.index);
                  },
                },
              }),
              h('a', {
                class: {
                  'iconfont': true,
                  'icon-edit': true,
                  'tm-icon-font': true,
                  'tm-icon-font-operation': true,
                },
                style: {
                  cursor: 'pointer',
                  marginLeft: '20px',
                },
                on: {
                  click: () => {
                    self.returnSetFunnel(params.row.name, params.index);
                  },
                },
              }),
            ]);
          },
        },
      ];
      this.$refs.tablepage.tableColumns = columns;
    },
    // 表格渲染
    setTableData() {
      this.setTableColumn();
      const params = {
        platformid: bus.platform.toString(),
        productid: bus.productInfo.productid,
      };
      $.ajax.get('app/rest/eventFlow.json/getByProduct', { params }).then((res) => {
        const data = res.map((eachfunnel) => {
          const temp = eachfunnel;
          // 获取steponename信息
          temp.steponename = eachfunnel.info[0].stepname || eachfunnel.info[0].eventid;
          // 获取endname信息
          temp.endname = eachfunnel.info.slice(-1)[0].stepname
            || eachfunnel.info.slice(-1)[0].eventid;
          return temp;
        });
        this.$refs.tablepage.changeData = data;
        this.$refs.tablepage.saveTableData = JSON.stringify(data);
        this.$refs.tablepage.tableData = this.$refs.tablepage.mockTableData(1, data);
      });
    },
    // 跳转新建转化漏斗
    setFunnel() {
      return this.$router.push({
        name: 'setfunnel',
        params: {
          funnelname: this.$t('funnel.funnelBtn'),
        },
      });
    },
    // 显示删除模态框
    showDelModal(a) {
      if (a.length > 0) {
        this.delModal = true;
        this.delSelection = a;
      }
    },
    // 隐藏删除模态框
    cancel() {
      this.delModal = false;
    },
    // 执行删除操作
    delFunnel() {
      for (let i = 0; i < this.delSelection.length; i += 1) {
        const ids = this.delSelection[i].id;
        const params = {
          developerid: bus.developerid,
          id: ids,
        };
        $.ajax.get('app/rest/eventFlow.json/deleteFlow', { params }).then((res) => {
          if (res) {
            const changeData = this.$refs.tablepage.changeData;
            for (let item = 0; item < changeData.length; item += 1) {
              if (ids === changeData[item].id) {
                changeData.splice(item, 1);
              }
            }
            const savedata = JSON.parse(this.$refs.tablepage.saveTableData);
            for (let item = 0; item < savedata.length; item += 1) {
              if (ids === savedata[item].id) {
                savedata.splice(item, 1);
              }
            }
            const cur = this.$refs.tablepage.cur;
            this.$refs.tablepage.saveTableData = savedata.length === 0 ?
              '' : JSON.stringify(savedata);
            this.$refs.tablepage.selection = [];
            this.$refs.tablepage.tableData = this.$refs.tablepage.mockTableData(cur, changeData);
          }
        });
      }
    },
    returnSetFunnel(name, index) {
      this.$refs.tablepage.returnSetFunnel(name, index);
    },
    returnFunnelChart(name, index) {
      this.$refs.tablepage.returnFunnelChart(name, index);
    },
  },
};
</script>

